import { useEffect, useState } from "react";
import { authApiV1 } from "../axiosWrapper";
import { 
    trackExceptionWithContext
} from '../services/application-insights/appInsights';
import { 
    AppInsightsComponents, 
    AppInsightsErrorTypes 
} from '../services/application-insights/appInsightsConstants';

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        authApiV1.get("/token/status")
            .then(() => {
                setIsAuthenticated(true);
            })
            .catch((error) => {
                setIsAuthenticated(false);
                // Only log exceptions, not regular auth checks
                trackExceptionWithContext(
                    error instanceof Error ? error : new Error(String(error)),
                    {
                        component: AppInsightsComponents.USE_AUTH_HOOK,
                        additionalData: {
                            errorType: AppInsightsErrorTypes.AUTHENTICATION_ERROR,
                            authMethod: "token-validation"
                        }
                    }
                );
            })
            .finally(() => setIsLoading(false));

    }, []);

    return { isAuthenticated, isLoading };
};
